export default "__VITE_ASSET__gbjdc$$i__"